"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const preact_custom_element_1 = __importDefault(require("preact-custom-element"));
const accordion_1 = __importDefault(require("./components/accordion"));
const disclosure_1 = __importDefault(require("./components/disclosure"));
const image_carousel_1 = __importDefault(require("./components/image-carousel"));
const newsletter_1 = __importDefault(require("./components/newsletter"));
customElements.define('compleat-accordion', accordion_1.default, {
    extends: 'ul',
});
customElements.define('compleat-disclosure-button', disclosure_1.default, {
    extends: 'button',
});
customElements.define('compleat-image-carousel', image_carousel_1.default, {
    extends: 'div',
});
(0, preact_custom_element_1.default)(newsletter_1.default, 'compleat-newsletter-form', ['list']);
